const COUNTRY_DIC = {
  1: {
    code: 'eg',
    name: 'Египет',
    rank: 0,
    url: 'egipet',
    sletat_id: 40,
    id: 1,
    recomend_list: [
      113, 108, 125, 133, 57028, 1960, 78898, 150, 174, 110, 293, 111, 393,
      79059, 55574, 1959, 178, 196, 66162, 109, 76150, 349, 81468, 236, 386,
      513, 340, 341, 371, 372, 76120, 75593, 67910, 37668, 358, 389, 482, 4184,
      12112, 9373, 476, 9374, 416, 32577, 478, 80964, 319, 496, 483, 77914,
      81173, 494, 4191, 78964,
    ],
  },
  2: {
    code: 'th',
    name: 'Таиланд',
    rank: 0,
    url: 'tailand',
    sletat_id: 113,
    id: 2,
    recomend_list: [],
  },
  3: {
    code: 'in',
    name: 'Индия',
    rank: 0,
    url: 'indiya',
    sletat_id: 44,
    id: 3,
    recomend_list: [],
  },
  4: {
    code: 'tr',
    name: 'Турция',
    rank: 0,
    url: 'turciya',
    sletat_id: 119,
    id: 4,
    recomend_list: [
      33266, 949, 954, 955, 956, 3423, 1146, 15869, 966, 78901, 39179, 973, 972,
      1429, 1581, 15909, 9318, 997, 1080, 1046, 16936, 1413, 1001, 1606, 1031,
      1005, 1007, 69646, 1032, 1032, 1033, 80068, 1036, 1257, 78383, 1057, 1059,
      21677, 1062, 1148, 15881, 9358, 83642, 1234, 82476, 1090, 1111, 76124,
      55750, 56019, 1123, 1126, 1133, 15910, 15910, 1136, 1137, 70233, 1094,
      78251, 70183, 1451, 27646, 1149, 1150, 9432, 1151, 3407, 2158, 29348,
      55205, 16938, 1164, 1414, 9270, 16935, 1500, 1193, 2166, 78264, 1643,
      1534, 1646, 54621, 28480, 1651, 76145, 1258, 1259, 1260, 1533, 1562, 9292,
      1278, 1279, 15892, 70137, 1281, 1191, 1488, 1253, 15904, 71476, 1064,
      1672, 1295, 1168, 15879, 75042, 1000, 1334, 47027, 1101, 1298, 1311,
      15877, 5528, 1035, 1454, 1386, 1522, 2178, 55833, 1338, 1341, 76588,
      76588, 1343, 21771, 69184, 1344, 59116, 1345, 35313, 3405, 27349, 1351,
      1112, 51374, 1375, 80249, 80249, 1689, 1354, 41305, 60196, 37384, 70455,
      2221, 74503, 1294, 975, 28327, 37566, 53512, 15890, 79959, 1402, 60402,
      77355, 65984, 69822, 1404, 1677, 16791, 1325, 28467, 9451, 2270, 15868,
      1107, 1418, 1491, 1420, 1421, 1422, 9326, 55645, 28326, 1436, 1693, 1563,
      1494, 82649, 1449, 1702, 28668, 1453, 1452, 9334, 5545, 1459, 3415, 53514,
      75041, 27426, 27426, 69077, 1004, 1478, 1456, 9320, 82604, 1335, 55828,
      976, 17654, 1348, 39190, 1352, 1495, 43228, 1507, 42932, 81389, 1527,
      37442, 66997, 1194, 2176, 49083, 49083, 2185, 1679, 21673, 3418, 9347,
      9349, 1568, 53513, 85457, 1582, 1583, 1586, 15873, 1590,
    ],
  },
  5: {
    code: 'tn',
    name: 'Тунис',
    rank: 2,
    url: 'tunis',
    sletat_id: 117,
    id: 5,
    recomend_list: [],
  },
  6: {
    code: 'gr',
    name: 'Греция',
    rank: 2,
    url: 'greciya',
    sletat_id: 35,
    id: 6,
    recomend_list: [],
  },
  7: {
    code: 'id',
    name: 'Индонезия',
    rank: 2,
    url: 'indoneziia',
    sletat_id: 45,
    id: 7,
    recomend_list: [],
  },
  8: {
    code: 'mv',
    name: 'Мальдивы',
    rank: 0,
    url: 'maldivskie-ostrova',
    sletat_id: 72,
    id: 8,
    recomend_list: [],
  },
  9: {
    code: 'ae',
    name: 'ОАЭ',
    rank: 0,
    url: 'oae',
    sletat_id: 90,
    id: 9,
    recomend_list: [
      15774, 13853, 52232, 42662, 54605, 2568, 2931, 2601, 8952, 25608, 4499,
      23283, 80431, 56236, 63833, 8964, 59226, 22676, 32232,
    ],
  },
  10: {
    code: 'cu',
    name: 'Куба',
    rank: 0,
    url: 'kuba',
    sletat_id: 61,
    id: 10,
    recomend_list: [
      57697, 57697, 2723, 2723, 20920, 20921, 8285, 8251, 4630, 20922, 33110,
      4643, 26819, 2724, 45417, 2717, 4624, 8272, 2697,
    ],
  },
  11: {
    code: 'do',
    name: 'Доминикана',
    rank: 2,
    url: 'dominikana',
    sletat_id: 39,
    id: 11,
    recomend_list: [],
  },
  12: {
    code: 'lk',
    name: 'Шри-Ланка',
    rank: 0,
    url: 'shri-lanka',
    sletat_id: 132,
    id: 12,
    recomend_list: [],
  },
  13: {
    code: 'cn',
    name: 'Китай',
    rank: 2,
    url: 'kitaj',
    sletat_id: 59,
    id: 13,
    recomend_list: [],
  },
  14: {
    code: 'es',
    name: 'Испания',
    rank: 2,
    url: 'ispaniya',
    sletat_id: 50,
    id: 14,
    recomend_list: [],
  },
  15: {
    code: 'cy',
    name: 'Кипр',
    rank: 2,
    url: 'kipr',
    sletat_id: 58,
    id: 15,
    recomend_list: [],
  },
  16: {
    code: 'vn',
    name: 'Вьетнам',
    rank: 0,
    url: 'vetnam',
    sletat_id: 29,
    id: 16,
    recomend_list: [],
  },
  17: {
    code: 'ad',
    name: 'Андорра',
    rank: 2,
    url: 'andorra',
    sletat_id: 7,
    id: 17,
    recomend_list: [],
  },
  18: {
    code: 'mx',
    name: 'Мексика',
    rank: 2,
    url: 'meksika',
    sletat_id: 77,
    id: 18,
    recomend_list: [],
  },
  19: {
    code: 'cz',
    name: 'Чехия',
    rank: 2,
    url: 'chekhiia',
    sletat_id: 128,
    id: 19,
    recomend_list: [],
  },
  20: {
    code: 'bg',
    name: 'Болгария',
    rank: 2,
    url: 'bolgariya',
    sletat_id: 19,
    id: 20,
    recomend_list: [],
  },
  21: {
    code: 'me',
    name: 'Черногория',
    rank: 2,
    url: 'chernogoriya',
    sletat_id: 127,
    id: 21,
    recomend_list: [],
  },
  22: {
    code: 'hr',
    name: 'Хорватия',
    rank: 2,
    url: 'horvatiya',
    sletat_id: 126,
    id: 22,
    recomend_list: [],
  },
  23: {
    code: 'ma',
    name: 'Марокко',
    rank: 2,
    url: 'marokko',
    sletat_id: 75,
    id: 23,
    recomend_list: [],
  },
  24: {
    code: 'it',
    name: 'Италия',
    rank: 2,
    url: 'italiya',
    sletat_id: 51,
    id: 24,
    recomend_list: [],
  },
  25: {
    code: 'sg',
    name: 'Сингапур',
    rank: 2,
    url: 'singapur',
    sletat_id: 108,
    id: 25,
    recomend_list: [],
  },
  26: {
    code: 'ph',
    name: 'Филиппины',
    rank: 2,
    url: 'filippiny',
    sletat_id: 123,
    id: 26,
    recomend_list: [],
  },
  27: {
    code: 'mu',
    name: 'Маврикий',
    rank: 2,
    url: 'mavrikij',
    sletat_id: 68,
    id: 27,
    recomend_list: [],
  },
  28: {
    code: 'sc',
    name: 'Сейшелы',
    rank: 2,
    url: 'sejshely',
    sletat_id: 105,
    id: 28,
    recomend_list: [],
  },
  29: {
    code: 'jo',
    name: 'Иордания',
    rank: 2,
    url: 'iordaniya',
    sletat_id: 46,
    id: 29,
    recomend_list: [],
  },
  30: {
    code: 'il',
    name: 'Израиль',
    rank: 2,
    url: 'izrail',
    sletat_id: 43,
    id: 30,
    recomend_list: [],
  },
  31: {
    code: 'at',
    name: 'Австрия',
    rank: 2,
    url: 'avstriya',
    sletat_id: 3,
    id: 31,
    recomend_list: [],
  },
  32: {
    code: 'fr',
    name: 'Франция',
    rank: 2,
    url: 'franciya',
    sletat_id: 125,
    id: 32,
    recomend_list: [],
  },
  33: {
    code: 'jm',
    name: 'Ямайка',
    rank: 2,
    url: 'yamajka',
    sletat_id: 138,
    id: 33,
    recomend_list: [],
  },
  34: {
    code: 'fi',
    name: 'Финляндия',
    rank: 2,
    url: 'finlyandiya',
    sletat_id: 124,
    id: 34,
    recomend_list: [],
  },
  35: {
    code: 'pt',
    name: 'Португалия',
    rank: 2,
    url: 'portugaliya',
    sletat_id: 99,
    id: 35,
    recomend_list: [],
  },
  36: {
    code: 'my',
    name: 'Малайзия',
    rank: 2,
    url: 'malajziya',
    sletat_id: 71,
    id: 36,
    recomend_list: [],
  },
  37: {
    code: 'hu',
    name: 'Венгрия',
    rank: 2,
    url: 'vengriya',
    sletat_id: 27,
    id: 37,
    recomend_list: [],
  },
  38: {
    code: 'de',
    name: 'Германия',
    rank: 2,
    url: 'germaniya',
    sletat_id: 149,
    id: 38,
    recomend_list: [],
  },
  39: {
    code: 'br',
    name: 'Бразилия',
    rank: 2,
    url: 'braziliya',
    sletat_id: 23,
    id: 39,
    recomend_list: [],
  },
  40: {
    code: 'kh',
    name: 'Камбоджа',
    rank: 2,
    url: 'kambodzha',
    sletat_id: 54,
    id: 40,
    recomend_list: [],
  },
  41: {
    code: 'tz',
    name: 'Танзания',
    rank: 2,
    url: 'tanzaniia',
    sletat_id: 115,
    id: 41,
    recomend_list: [],
  },
  42: {
    code: 'sk',
    name: 'Словакия',
    rank: 2,
    url: 'slovakiya',
    sletat_id: 110,
    id: 42,
    recomend_list: [],
  },
  43: {
    code: 'si',
    name: 'Словения',
    rank: 2,
    url: 'sloveniya',
    sletat_id: 111,
    id: 43,
    recomend_list: [],
  },
  44: {
    code: 'gb',
    name: 'Великобритания',
    rank: 2,
    url: 'velikobritaniya',
    sletat_id: 26,
    id: 44,
    recomend_list: [],
  },
  45: {
    code: 'nl',
    name: 'Нидерланды',
    rank: 2,
    url: 'niderlandy',
    sletat_id: 86,
    id: 45,
    recomend_list: [],
  },
  46: {
    code: 'ab',
    name: 'Абхазия',
    rank: 0,
    url: 'abhaziya',
    sletat_id: 1,
    id: 46,
    recomend_list: [63662, 75492, 54200, 57311, 82762, 76088, 32449, 30076],
  },
  47: {
    code: 'ru',
    name: 'Курорты России',
    rank: 0,
    url: 'rossiia',
    sletat_id: 150,
    id: 47,
    recomend_list: [
      77372, 30369, 79583, 76577, 30452, 58198, 30403, 30460, 79590, 82216,
      30493, 71787, 76645, 76090, 38425, 48247, 30300, 30285,
    ],
  },
  48: {
    code: 'us',
    name: 'США',
    rank: 2,
    url: 'usa',
    sletat_id: 112,
    id: 48,
    recomend_list: [],
  },
  49: {
    code: 'jp',
    name: 'Япония',
    rank: 2,
    url: 'yaponiya',
    sletat_id: 139,
    id: 49,
    recomend_list: [],
  },
  50: {
    code: 'mt',
    name: 'Мальта',
    rank: 2,
    url: 'malta',
    sletat_id: 73,
    id: 50,
    recomend_list: [],
  },
  51: {
    code: 'ke',
    name: 'Кения',
    rank: 2,
    url: 'keniya',
    sletat_id: 57,
    id: 51,
    recomend_list: [],
  },
  52: {
    code: 'ch',
    name: 'Швейцария',
    rank: 2,
    url: 'shveycariya',
    sletat_id: 130,
    id: 52,
    recomend_list: [],
  },
  53: {
    code: 'am',
    name: 'Армения',
    rank: 2,
    url: 'armeniya',
    sletat_id: 10,
    id: 53,
    recomend_list: [],
  },
  54: {
    code: 'ge',
    name: 'Грузия',
    rank: 0,
    url: 'gruziya',
    sletat_id: 36,
    id: 54,
    recomend_list: [],
  },
  55: {
    code: 'az',
    name: 'Азербайджан',
    rank: 2,
    url: 'azerbajdzhan',
    sletat_id: 4,
    id: 55,
    recomend_list: [],
  },
  56: {
    code: 'uz',
    name: 'Узбекистан',
    rank: 2,
    url: 'uzbekistan',
    sletat_id: 120,
    id: 56,
    recomend_list: [],
  },
  57: {
    code: 'by',
    name: 'Беларусь',
    rank: 2,
    url: 'belarus',
    sletat_id: 16,
    id: 57,
    recomend_list: [],
  },
  58: {
    code: 'rs',
    name: 'Сербия',
    rank: 2,
    url: 'serbiya',
    sletat_id: 107,
    id: 58,
    recomend_list: [],
  },
  59: {
    code: 'bh',
    name: 'Бахрейн',
    rank: 2,
    url: 'bahrejn',
    sletat_id: 15,
    id: 59,
    recomend_list: [],
  },
  60: {
    code: 'kg',
    name: 'Киргизия',
    rank: 2,
    url: 'kyrgyzctan',
    sletat_id: 62,
    id: 60,
    recomend_list: [],
  },
  61: {
    code: 'cr',
    name: 'Коста-Рика',
    rank: 2,
    url: 'kosta-rika',
    sletat_id: 60,
    id: 61,
    recomend_list: [],
  },
  62: {
    code: 'lv',
    name: 'Латвия',
    rank: 2,
    url: 'latviya',
    sletat_id: 64,
    id: 62,
    recomend_list: [],
  },
  64: {
    code: 'om',
    name: 'Оман',
    rank: 2,
    url: 'oman',
    sletat_id: 91,
    id: 64,
    recomend_list: [],
  },
  66: {
    code: 'ro',
    name: 'Румыния',
    rank: 2,
    url: 'rumyniia',
    sletat_id: 102,
    id: 66,
    recomend_list: [],
  },
  70: {
    code: 'kr',
    name: 'Южная Корея',
    rank: 2,
    url: 'yuzhnaya-koreya',
    sletat_id: 137,
    id: 70,
    recomend_list: [],
  },
  71: {
    code: 'al',
    name: 'Албания',
    rank: 2,
    url: 'albaniya',
    sletat_id: 5,
    id: 71,
    recomend_list: [],
  },
  72: {
    code: 'aw',
    name: 'Аруба',
    rank: 2,
    url: 'aruba',
    sletat_id: 11,
    id: 72,
    recomend_list: [],
  },
  73: {
    code: 'bs',
    name: 'Багамы',
    rank: 2,
    url: 'bagamskie-ostrova',
    sletat_id: 12,
    id: 73,
    recomend_list: [],
  },
  74: {
    code: 'be',
    name: 'Бельгия',
    rank: 2,
    url: 'belgiya',
    sletat_id: 18,
    id: 74,
    recomend_list: [],
  },
  75: {
    code: 'dk',
    name: 'Дания',
    rank: 2,
    url: 'daniia',
    sletat_id: 37,
    id: 75,
    recomend_list: [],
  },
  78: {
    code: 'kz',
    name: 'Казахстан',
    rank: 0,
    url: 'kazakhstan',
    sletat_id: 53,
    id: 78,
    recomend_list: [72063],
  },
  79: {
    code: 'qa',
    name: 'Катар',
    rank: 2,
    url: 'katar',
    sletat_id: 56,
    id: 79,
    recomend_list: [],
  },
  83: {
    code: 'no',
    name: 'Норвегия',
    rank: 2,
    url: 'norvegiya',
    sletat_id: 88,
    id: 83,
    recomend_list: [],
  },
  84: {
    code: 'se',
    name: 'Швеция',
    rank: 2,
    url: 'shveciya',
    sletat_id: 131,
    id: 84,
    recomend_list: [],
  },
  85: {
    code: 'za',
    name: 'ЮАР',
    rank: 2,
    url: 'yuar',
    sletat_id: 136,
    id: 85,
    recomend_list: [],
  },
  90: {
    code: 've',
    name: 'Венесуэла',
    rank: 2,
    url: 'tury-v-venesuelu',
    sletat_id: 28,
    id: 90,
    recomend_list: [],
  },
  92: {
    code: 'ir',
    name: 'Иран',
    rank: 2,
    url: 'iran',
    sletat_id: 47,
    id: 92,
    recomend_list: [],
  },
};

export default COUNTRY_DIC;
